// DEV-ONLY: renders the real Pools screens against the in-memory fake database.
// Open http://localhost:3000/?poolPreview  (never active in a production build)
import React, { useEffect, useState } from 'react';
import api from '../api';
import PoolsView from '../components/pools/PoolsView';
import { PREVIEW_USER_ID, seedPlayers, fakeStandings, setPreviewOption } from './fakeSupabase';
import './poolsPreview.css';

// A few palettes to check the pool screens against team themes
const THEMES = {
  default: {},
  canadiens: {
    '--accent': '#AF1E2D', '--accent-dark': '#8f1824', '--accent-hover': '#c42d3c', '--accent-rgb': '175, 30, 45',
    '--ui-accent': '#192168', '--header-bg': '#AF1E2D', '--header-accent': '#192168',
  },
  kings: {
    '--accent': '#A2AAAD', '--accent-dark': '#848c8f', '--accent-hover': '#c0c8cb', '--accent-rgb': '162, 170, 173',
    '--ui-accent': '#A2AAAD', '--header-bg': '#111111', '--header-accent': '#A2AAAD',
    '--bg-dark': '#1c1c1c', '--bg-card': '#121212', '--bg-hover': '#0d0d0d', '--border': '#333333',
    '--text': '#f5f5f5', '--text-muted': '#aaaaaa',
  },
};
const ALL_VARS = [...new Set(Object.values(THEMES).flatMap((t) => Object.keys(t)))];

export default function PoolsPreview() {
  const [ready, setReady] = useState(false);
  const [theme, setTheme] = useState('default');
  const [lang, setLang] = useState('en');
  const [fast, setFast] = useState(false);
  const [autoMe, setAutoMe] = useState(false);
  useEffect(() => { setPreviewOption('fast', fast); }, [fast]);
  useEffect(() => { setPreviewOption('autoMe', autoMe); }, [autoMe]);

  useEffect(() => {
    // Standings come from the fake data too
    api.fetchPoolStandings = async (poolId) => fakeStandings(poolId);
    // Fake "today's games": a few teams already playing (their players are locked), the rest at 7 PM
    api.fetchNhlToday = async () => {
      const abbrevs = ['ANA','BOS','BUF','CGY','CAR','CHI','COL','CBJ','DAL','DET','EDM','FLA','LAK','MIN','MTL','NSH',
        'NJD','NYI','NYR','OTT','PHI','PIT','SJS','SEA','STL','TBL','TOR','UTA','VAN','VGK','WSH','WPG'];
      const tonight = new Date(); tonight.setHours(19, 0, 0, 0);
      const teams = {};
      for (let i = 0; i < abbrevs.length; i += 2) {
        const [home, away] = [abbrevs[i], abbrevs[i + 1]];
        const started = i < 6; // first 3 games already under way
        const g = { startTimeUTC: started ? new Date(Date.now() - 3600000).toISOString() : tonight.toISOString(), started, state: started ? 'LIVE' : 'FUT' };
        teams[home] = { ...g, opponent: away, home: true };
        teams[away] = { ...g, opponent: home, home: false };
      }
      return { date: new Date().toISOString().slice(0, 10), teams };
    };
    (async () => {
      try {
        const res = await api.fetchRosters(); // read-only NHL rosters from the local server
        seedPlayers(res?.players || []);
      } catch (e) {
        seedPlayers([]);
      }
      setReady(true);
    })();
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    ALL_VARS.forEach((v) => root.style.removeProperty(v));
    Object.entries(THEMES[theme]).forEach(([k, v]) => root.style.setProperty(k, v));
  }, [theme]);

  return (
    <div className="pools-preview">
      <div className="pools-preview-bar">
        <strong>POOLS PREVIEW</strong>
        <span className="pools-preview-note">Fake data · nothing is saved · reload to reset</span>
        <span className="pools-preview-spacer" />
        <label className="pools-preview-check">
          <input type="checkbox" checked={fast} onChange={(e) => setFast(e.target.checked)} /> Fast draft
        </label>
        <label className="pools-preview-check">
          <input type="checkbox" checked={autoMe} onChange={(e) => setAutoMe(e.target.checked)} /> Auto-pick for me
        </label>
        <label>
          Theme{' '}
          <select value={theme} onChange={(e) => setTheme(e.target.value)}>
            <option value="default">Default</option>
            <option value="canadiens">Canadiens</option>
            <option value="kings">Kings (dark)</option>
          </select>
        </label>
        <label>
          Lang{' '}
          <select value={lang} onChange={(e) => setLang(e.target.value)}>
            <option value="en">EN</option>
            <option value="fr">FR</option>
          </select>
        </label>
      </div>
      <div className="pools-preview-body">
        {ready
          ? <PoolsView userId={PREVIEW_USER_ID} lang={lang} onBalanceChange={() => {}} />
          : <div className="pools-empty">Loading preview…</div>}
      </div>
    </div>
  );
}
